var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.popupClasses()},[_c('img',{attrs:{"src":require("../../assets/images/icons/small_close_icon.svg"),"alt":"Notification close icon"},on:{"click":function($event){return _vm.closePopup()}}}),_c('h3',[_vm._v(_vm._s(this.title))]),_c('p',[_vm._v(_vm._s(this.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }